<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app class="primary" dark>
      <v-list-item>
        <v-list-item-content>
          <v-img height="50" contain src="@/assets/logo.png"></v-img>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content class="text-center">
          <h3>{{userData.orgName}}</h3>
          <p>{{userData.name}}</p>
        </v-list-item-content>
      </v-list-item>

      <v-list dense>
        <v-list-item link to="/admin/clients">
          <v-list-item-action>
            <v-icon>mdi-account-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>CLIENTES</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/client/home">
          <v-list-item-action>
            <v-icon>mdi-account-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>ÁREA DE CLIENTES</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link to="/admin/aspects">
          <v-list-item-action>
            <v-icon>mdi-bookmark-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>ASPECTOS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/admin/reactives">
          <v-list-item-action>
            <v-icon>mdi-bookmark-multiple-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>REACTIVOS</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/admin/helpclient">
          <v-list-item-action>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>AYUDA CLIENTE</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/admin/helpparticipant">
          <v-list-item-action>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>AYUDA EMPLEADO</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider></v-divider>

        <v-list-item link @click="logOut">
          <v-list-item-action>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>CERRAR SESIÓN</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="indigo" dark class="hidden-lg-and-up">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        <v-img height="40" contain src="@/assets/logo.png"></v-img>
      </v-toolbar-title>
    </v-app-bar>

    <v-content style="padding : 2rem" :class="{'mt-n12' : margin}">
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  data: () => ({
    drawer: null,
    margin: false
  }),
  computed: {
    ...mapState(["userData"])
  },
  methods: {
    ...mapMutations(["setUser"]),
    logOut() {
      sessionStorage.removeItem("authorization");
      this.$router.push("/");
    },
    onResize() {
      if (this.$vuetify.breakpoint.lgAndUp) {
        this.margin = true;
      } else {
        this.margin = false;
      }
    }
  },
  mounted() {
    this.setUser(JSON.parse(sessionStorage.getItem("user")));
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  }
};
</script>